import 'css-chunksrc/client/scenes/inviteMembers/styles.scss';export default {
  "message": "_message_6t2z0_1",
  "label": "_label_6t2z0_8",
  "forms": "_forms_6t2z0_14",
  "form": "_form_6t2z0_14",
  "member": "_member_6t2z0_33",
  "iconBox": "_iconBox_6t2z0_40",
  "icon": "_icon_6t2z0_40",
  "group": "_group_6t2z0_61",
  "text": "_text_6t2z0_65",
  "name": "_name_6t2z0_70",
  "main": "_main_6t2z0_76",
  "messageForm": "_messageForm_6t2z0_84",
  "messageInput": "_messageInput_6t2z0_88",
  "buttons": "_buttons_6t2z0_92",
  "addResourceButton": "_addResourceButton_6t2z0_101",
  "removeIconBox": "_removeIconBox_6t2z0_109",
  "removeIcon": "_removeIcon_6t2z0_109"
};